// Tabs of the Corporate Campaign "What we offer" block.
const campaignTabs = {
    init() {
        document.addEventListener('click', (e) => {
            const tab = e.target.closest('.js-cc-offer-tab');

            if (!tab) {
                return;
            }

            const block = tab.closest('.corporate-campaign-what-we-offer');

            block.querySelectorAll('.js-cc-offer-tab').forEach((item) => {
                const isActive = item === tab;
                const panel = document.getElementById(item.getAttribute('aria-controls'));

                item.classList.toggle('is-active', isActive);
                item.setAttribute('aria-selected', isActive ? 'true' : 'false');

                if (panel) {
                    panel.classList.toggle('is-active', isActive);
                    panel.hidden = !isActive;
                }
            });
        });
    }
}

export default campaignTabs
